export const BUTTON_SAVE_COLOR = '#4caf50'; // Green
export const BUTTON_CANCEL_COLOR = '#f44336'; // Red
export const BUTTON_ADD_COLOR = '#2196f3'; // Blue